import { memo } from 'react';
import { Boldik, cn } from '@divlab/divanui';
import { IconChevronRight, IconLocation } from '@divlab/divanui/icons';

import { useRequest } from '@Contexts/Request';
import * as HeaderStore from '@Stores/Header';
import * as ModalWindows from '@Stores/ModalWindows';
import * as Meta from '@Queries/Meta';
import UILink from '@UI/Link';
import FeedbackPhone from '@Components/FeedbackPhone';
import SmartRender from '@Components/SmartRender';
import styles from './MenuLeft.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';

export interface MenuLeftProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const MenuLeft: FC<MenuLeftProps> = (props) => {
  const { className, ...oldProps } = props;
  const meta = Meta.useMeta();
  const { country } = useRequest();
  const isRus = country === 'RUS';

  const handleClickLocation = () => {
    HeaderStore.closeMenu();
    ModalWindows.open('RegionSelector', { context: { source: 'topline-header-menu' } });
  };

  const handleClickPhone = (e: MouseEvent) => {
    if (isRus) return;

    e.preventDefault();
    HeaderStore.closeMenu();
    ModalWindows.open('Feedback');
  };

  return (
    <div {...oldProps} className={cn(styles.mainWrapper, className)}>
      <UILink
        className={styles.location}
        underlined
        onClick={handleClickLocation}
        data-testid='region-name-link'
      >
        <div className={styles.locationIconWrapper}>
          <IconLocation className={styles.locationIcon} />
        </div>

        <Boldik className={styles.locationText}>{meta.data.region.name}</Boldik>
        <IconChevronRight className={styles.locationArrow} />
      </UILink>

      <div onClick={handleClickPhone} className={styles.callback} data-testid='callback'>
        <FeedbackPhone cnPhone={styles.callbackText} view='primary' className={styles.phone} />
        <SmartRender countries={['BLR', 'KAZ', 'UZB']}>
          <IconChevronRight className={styles.callbackArrow} />
        </SmartRender>
      </div>
    </div>
  );
};

export default memo(MenuLeft);
